module.exports = __webpack_public_path__ + "static/sanderdoorn_3-a575851ffd96b2b7bfd3ed68ea60167d.jpg";